module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_20.2a602ee4.png";